<section class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-lg-6">
        <span class="cat__core__title">Create Company</span>
      </div>
      <div class="col-lg-6 text-right">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany Logo" class="form-logo">
      </div>
    </div>
  </div>
  <div class="card-block">
    <div class="row">
      <div class="col-lg-12">
        <form [formGroup]="trialCompanyForm" class="well">
          <div class="modal-body">
            
            <!-- Basic Company Information -->
            <h4 class="title mb-3">Company Information</h4>
            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Company Name <span style="color: red;">*</span>
                  <span style="font-style: italic;font-size: 12px;">As registered with ROC</span>
                </label>
                <div class="form-group">
                  <input class="form-control" placeholder="Company Name" name="companyName" [formControl]="trialCompanyForm.controls['companyName']">
                  <div *ngIf="trialCompanyForm.controls['companyName'].hasError('required') && trialCompanyForm.controls['companyName'].touched"
                    class="form-control-error-custom">
                    Company name is required.
                  </div>
                  <div *ngIf="trialCompanyForm.controls['companyName'].hasError('maxlength') && trialCompanyForm.controls['companyName'].touched"
                    class="form-control-error-custom">
                    Company name should be maximum 100 character.
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Symbol</label>
                <div class="form-group">
                  <input class="form-control" type="text" placeholder="Symbol" name="symbol" [formControl]="trialCompanyForm.controls['symbol']">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">API URL <span class="text-muted">(Auto-configured)</span></label>
                <div class="form-group">
                  <input class="form-control" placeholder="URL" name="url" [formControl]="trialCompanyForm.controls['complianceEngineURL']" readonly>
                  <small class="form-text text-muted">This field is auto-configured for trial companies.</small>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <label class="form-control-label">Website URL <span class="text-muted">(Auto-configured)</span></label>
                <div class="form-group">
                  <input class="form-control" type="url" placeholder="URL" name="url" [formControl]="trialCompanyForm.controls['chatEngineURL']" readonly>
                  <small class="form-text text-muted">This field is auto-configured for trial companies.</small>
                </div>
              </div>
            </div>

            <!-- Registration Details -->
            <h4 class="title mb-3 mt-4">Registration Details</h4>
            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Registration ID Type <span class="text-muted">(Auto-configured)</span></label>
                <div class="form-group">
                  <input class="form-control" [formControl]="trialCompanyForm.controls['registrationIDType']" readonly>
                  <small class="form-text text-muted">Registration type is set to CIN for trial companies.</small>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Registration Number <span class="text-muted">(Auto-configured)</span></label>
                <div class="form-group">
                  <input class="form-control" placeholder="Registration Number" name="registrationNumber" [formControl]="trialCompanyForm.controls['registrationNumber']" readonly>
                  <small class="form-text text-muted">Registration number is auto-generated for trial companies.</small>
                </div>
              </div>
            </div>

            <!-- Company Classification -->
            <h4 class="title mb-3 mt-4">Company Classification</h4>
            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Type of Company <span style="color: red;">*</span></label>
                <div class="form-group">
                  <select class="form-control" [formControl]="trialCompanyForm.controls['typeOfCompany']">
                    <option value="">Select Type</option>
                    <option *ngFor="let type of typesOfCompany" [value]="type.value">{{ type.label }}</option>
                  </select>
                  <div *ngIf="trialCompanyForm.controls['typeOfCompany'].hasError('required') && trialCompanyForm.controls['typeOfCompany'].touched"
                    class="form-control-error-custom">
                    Type of Company is required.
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Category of Company <span style="color: red;">*</span></label>
                <div class="form-group">
                  <select class="form-control" [formControl]="trialCompanyForm.controls['categoryOfCompany']">
                    <option value="">Select Category</option>
                    <option *ngFor="let category of categoriesOfCompany" [value]="category.value">{{ category.label }}</option>
                  </select>
                  <div *ngIf="trialCompanyForm.controls['categoryOfCompany'].hasError('required') && trialCompanyForm.controls['categoryOfCompany'].touched"
                    class="form-control-error-custom">
                    Category of Company is required.
                  </div>
                </div>
              </div>
            </div>

            <!-- Address Information -->
            <h4 class="title mb-3 mt-4">Address Information</h4>
            <div class="row">
              <div class="col-md-12">
                <label class="form-control-label" for="l0">Registered Office Address <span style="color: red;">*</span></label>
                <div class="form-group">
                  <textarea class="form-control" rows="3" placeholder="Registered Office Address" [formControl]="trialCompanyForm.controls['registeredOfficeAddress']"></textarea>
                  <div *ngIf="trialCompanyForm.controls['registeredOfficeAddress'].hasError('required') && trialCompanyForm.controls['registeredOfficeAddress'].touched"
                    class="form-control-error-custom">
                    Address is required.
                  </div>
                  <div *ngIf="trialCompanyForm.controls['registeredOfficeAddress'].hasError('minlength') && trialCompanyForm.controls['registeredOfficeAddress'].touched"
                    class="form-control-error-custom">
                    Address should be minimum 10 characters.
                  </div>
                  <div *ngIf="trialCompanyForm.controls['registeredOfficeAddress'].hasError('maxlength') && trialCompanyForm.controls['registeredOfficeAddress'].touched"
                    class="form-control-error-custom">
                    Address should be maximum 500 characters.
                  </div>
                </div>
              </div>
            </div>

            <!-- Financial Information -->
            <h4 class="title mb-3 mt-4">Financial Information</h4>
            <div class="row">
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Date of Incorporation</label>
                <div class="form-group">
                  <input class="form-control" type="date" [formControl]="trialCompanyForm.controls['dateOfIncorporation']">
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Financial Year From <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" type="date" [formControl]="trialCompanyForm.controls['FinancialYearFrom']">
                  <div *ngIf="trialCompanyForm.controls['FinancialYearFrom'].hasError('required') && trialCompanyForm.controls['FinancialYearFrom'].touched"
                    class="form-control-error-custom">
                    Financial Year From is required.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Financial Year To <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" type="date" [formControl]="trialCompanyForm.controls['FinancialYearTo']">
                  <div *ngIf="trialCompanyForm.controls['FinancialYearTo'].hasError('required') && trialCompanyForm.controls['FinancialYearTo'].touched"
                    class="form-control-error-custom">
                    Financial Year To is required.
                  </div>
                </div>
              </div>
            </div>

            <!-- Listing Information -->
            <h4 class="title mb-3 mt-4">Listing Information</h4>
            <div class="row checkbox-row">
              <div class="col-md-3">
                <div class="checkbox-wrapper">
                  <label class="form-control-label">Is Listed Company</label>
                  <div class="form-group">
                    <label class="container">
                      <input type="checkbox" [formControl]="trialCompanyForm.controls['listedCompany']">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="checkbox-wrapper">
                  <label class="form-control-label">Equity Listing</label>
                  <div class="form-group">
                    <label class="container">
                      <input type="checkbox" [formControl]="trialCompanyForm.controls['equityListing']">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="checkbox-wrapper">
                  <label class="form-control-label">Debt Listing</label>
                  <div class="form-group">
                    <label class="container">
                      <input type="checkbox" [formControl]="trialCompanyForm.controls['debtListing']">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="checkbox-wrapper">
                  <label class="form-control-label">Accepts Deposits</label>
                  <div class="form-group">
                    <label class="container">
                      <input type="checkbox" [formControl]="trialCompanyForm.controls['acceptsDeposits']">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-3">
                <label class="form-control-label">Number of Shareholders</label>
                <div class="form-group">
                  <input class="form-control" type="number" placeholder="Number of Shareholders" [formControl]="trialCompanyForm.controls['noOfShareholders']">
                  <!-- <div *ngIf="trialCompanyForm.controls['noOfShareholders'].hasError('required') && trialCompanyForm.controls['noOfShareholders'].touched"
                    class="form-control-error-custom">
                    Number of Shareholders is required.
                  </div> -->
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-control-label">Number of Debenture Holders</label>
                <div class="form-group">
                  <input class="form-control" type="number" placeholder="Number" [formControl]="trialCompanyForm.controls['noOfDebentureHolders']">
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-control-label">Number of Deposit Holders</label>
                <div class="form-group">
                  <input class="form-control" type="number" placeholder="Number" [formControl]="trialCompanyForm.controls['noOfDepositHolders']">
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-control-label">Number of Security Holders</label>
                <div class="form-group">
                  <input class="form-control" type="number" placeholder="Number" [formControl]="trialCompanyForm.controls['noOfSecurityHolders']">
                </div>
              </div>
            </div>

            <!-- Subscription Information -->
            <!-- <h4 class="title mb-3 mt-4">Subscription Information</h4>
            <div class="row">
              <div class="col-md-2 mt-4">
                <label class="form-control-label">Is DigiCompany Boards Subscribed</label>
              </div>
              <div class="col-md-4 mt-4">
                <div class="form-group">
                  <label class="container">
                    <input type="checkbox" [formControl]="trialCompanyForm.controls['isGEMSubscribedFlag']"
                      (change)="onGEMSubscriptionChange($event)">
                      <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-md-6" *ngIf="trialCompanyForm.get('isGEMSubscribedFlag')?.value">
                <label class="form-control-label">DigiCompany Boards API URL <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" type="url" placeholder="URL" name="url" [formControl]="trialCompanyForm.controls['GEMAccessURL']">
                  <div *ngIf="trialCompanyForm.controls['GEMAccessURL'].hasError('required') && trialCompanyForm.controls['GEMAccessURL'].touched"
                    class="form-control-error-custom">
                    DigiCompany Boards URL is required.
                  </div>
                </div>
              </div>
            </div> -->

            <!-- Admin Contact Information -->
            <!-- <h4 class="title mb-3 mt-4">Admin Contact Information</h4>
            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Admin First Name <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" placeholder="First Name" name="adminFirstName" [formControl]="trialCompanyForm.controls['adminFirstName']">
                  <div *ngIf="trialCompanyForm.controls['adminFirstName'].hasError('required') && trialCompanyForm.controls['adminFirstName'].touched"
                    class="form-control-error-custom">
                    Admin First Name is required.
                  </div>
                  <div *ngIf="trialCompanyForm.controls['adminFirstName'].hasError('pattern') && trialCompanyForm.controls['adminFirstName'].touched"
                    class="form-control-error-custom">
                    Please enter valid First Name.
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Admin Last Name <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" placeholder="Last Name" name="adminLastName" [formControl]="trialCompanyForm.controls['adminLastName']">
                  <div *ngIf="trialCompanyForm.controls['adminLastName'].hasError('required') && trialCompanyForm.controls['adminLastName'].touched"
                    class="form-control-error-custom">
                    Admin Last Name is required.
                  </div>
                  <div *ngIf="trialCompanyForm.controls['adminLastName'].hasError('pattern') && trialCompanyForm.controls['adminLastName'].touched"
                    class="form-control-error-custom">
                    Please enter valid Last Name.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Admin Email <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" type="email" placeholder="Email" name="adminEmail" [formControl]="trialCompanyForm.controls['adminEmail']">
                  <div *ngIf="trialCompanyForm.controls['adminEmail'].hasError('required') && trialCompanyForm.controls['adminEmail'].touched"
                    class="form-control-error-custom">
                    Admin Email is required.
                  </div>
                  <div *ngIf="trialCompanyForm.controls['adminEmail'].hasError('email') && trialCompanyForm.controls['adminEmail'].touched"
                    class="form-control-error-custom">
                    Please enter valid Email.
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Admin Mobile Number <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" type="tel" placeholder="Mobile Number" name="adminMobileNumber" [formControl]="trialCompanyForm.controls['adminMobileNumber']">
                  <div *ngIf="trialCompanyForm.controls['adminMobileNumber'].hasError('required') && trialCompanyForm.controls['adminMobileNumber'].touched"
                    class="form-control-error-custom">
                    Admin Mobile Number is required.
                  </div>
                  <div *ngIf="trialCompanyForm.controls['adminMobileNumber'].hasError('pattern') && trialCompanyForm.controls['adminMobileNumber'].touched"
                    class="form-control-error-custom">
                    Please enter valid 10-digit Mobile Number.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <label class="form-control-label" for="l0">Admin Designation <span style="color: red;">*</span></label>
                <div class="form-group">
                  <input class="form-control" placeholder="Designation" name="adminDesignation" [formControl]="trialCompanyForm.controls['adminDesignation']">
                  <div *ngIf="trialCompanyForm.controls['adminDesignation'].hasError('required') && trialCompanyForm.controls['adminDesignation'].touched"
                    class="form-control-error-custom">
                    Admin Designation is required.
                  </div>
                </div>
              </div>
            </div> -->

            <!-- Submit Button -->
            <div class="row mt-4">
              <div class="col-md-12 text-center">
                <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()">
                  <i class="fa fa-plus mr-2" aria-hidden="true"></i>Create Trial Company
                </button>
                <div class="mt-2">
                  <small class="text-muted">Form Status: {{ trialCompanyForm.valid ? 'Valid ✓' : 'Invalid ✗' }}</small>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<app-alert></app-alert>